import parse from "html-react-parser"

function parseHtml(html) {

    if (html.indexOf("addictiontraining.org") >= 0) {
        html = html.replace(/https:\/\/www.addictiontraining.org\/REMS/g,
            'https://www.accessdata.fda.gov/scripts/cder/rems/index.cfm?event=IndvRemsDetails.page&REMS=376');
        html = html.replace(/https:\/\/www.addictiontraining.org\/consent/g,
            'https://www.addictiontraining.org/resources/?category=11');
        html = html.replace(/https:\/\/www.addictiontraining.org\/injection/g,
            'https://www.youtube.com/embed/y9UP6C5Gsf8');
            html = html.replace(/https:\/\/www.addictiontraining.org\/42CFR/g,
            'https://www.coephi.org/');
    }

    return parse(html);
}

export default parseHtml;